module.exports = __webpack_public_path__ + "img/lens-174-plus-04.eb0dbc11.png";